// Interrupteur global « Validation automatique (bypass gérant) ».
// Lorsqu'il est actif, toute nouvelle opération soumise à l'accord du gérant
// est validée immédiatement, avec la même imputation que la validation manuelle.
const KEY = 'oliva.validation';

export const AUTO_VALIDATION_AUTEUR = 'Auto-validation';

export function getAutoValidation() {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '{}').auto === true;
  } catch {
    return false;
  }
}

export function setAutoValidation(actif) {
  localStorage.setItem(KEY, JSON.stringify({ auto: actif === true, maj: new Date().toISOString() }));
  window.dispatchEvent(new Event('validation-maj'));
  return actif === true;
}
